import { parseLink } from '@/services/parselinkService'
export default {
  props: {
    href: {
      type: String,
      required: true,
    },

    label: {
      type: String,
      required: true,
    },

    video_label: {
      type: String,
    },

    video_href: {
      type: String,
    },

    download_label: {
      type: String,
    },

    download_href: {
      type: String,
    },
  },

  data() {
    return {
      isCardVideo: false,
      isCardDownload: false,
      cardIconImage: '/static/app-hotmart-legal/images/download-icon.png',
    }
  },

  methods: {
    parseLinks(payload) {
      const { path, locale } = payload
      const newUrl = parseLink(path)

      return newUrl
    },

    enableCardVideo() {
      this.isCardVideo = true
      this.isCardDownload = false
    },

    disableCardVideo() {
      this.isCardVideo = false
    },

    enableCardDownload() {
      this.isCardDownload = true
      this.isCardVideo = false
    },

    disableCardDownload() {
      this.isCardDownload = false

      this.updateImg(false)
    },

    clickCardDownload() {
      this.updateImg(true)
    },

    updateImg(isCardDownloadClicked) {
      const image = isCardDownloadClicked ? 'download__completed-icon.png' : 'download-icon.png'

      this.cardIconImage = `/static/app-hotmart-legal/images/${image}`
    },
  },

  computed: {
    video() {
      if (this.video_label && this.video_href) {
        return {
          label: this.video_label,
          href: this.video_href,
        }
      }

      return null
    },

    download() {
      if (this.download_label && this.download_href) {
        return {
          label: this.download_label,
          href: this.download_href,
        }
      }

      return null
    },
  },
}
